import client from './client';

export const packageDepartmentsApi = {
  getAll() {
    return client.get('/package-departments/admin');
  },
  create(data) {
    return client.post('/package-departments', data);
  },
  delete(id) {
    return client.delete(`/package-departments/${id}`);
  },
};
